// let apiUrl = `https://wisesense.avers.io/server`;
let apiUrl = process.env.REACT_APP_API_URL || `http://localhost:443`;
const apiPrefix = "api";
const authPrefix = "auth";
console.log(apiUrl);
apiUrl = `${apiUrl}/${apiPrefix}`;

export const HTTP_ENDPOINTS = Object.freeze({
  SOCKET_URL: apiUrl,
  API_URL: apiUrl,
  // LOGIN: `${apiUrl}/${authPrefix}/login`,
  // LOGOUT: `${apiUrl}/${authPrefix}/logout`,
  USER_INFO: `${apiUrl}/${authPrefix}/userinfo`,

  ALERTS: `${apiUrl}/alerts`,
  ALERTS_STATISTICS: `${apiUrl}/alerts/statistics`,
  ALERTS_CART_STATISTICS: `${apiUrl}/alerts/cartStatistics`,
  ALERTS_CART_STATISTICS_ONLY: `${apiUrl}/alerts/cartStatisticsOnly`,
  ALERTS_STORE_HOURS_STATISTICS: `${apiUrl}/alerts/storeHoursStatistics`,
  UPDATE_ALERT_STATUS: `${apiUrl}/alerts/updateAlertStatus`,
  DOWNLOAD_STORE_HOURS_STATISTICS_REPORT: `${apiUrl}/alerts/downloadStoreHoursStatistics`,

  PRODUCTS: `${apiUrl}/products`,

  OPTIONS: `${apiUrl}/options`,
  STORE_SETTINGS: `${apiUrl}/options/storeSettings`,

  USERS: `${apiUrl}/users`,
  LOGIN: `${apiUrl}/users/login`,
  REGISTER: `${apiUrl}/users/register`,

  EQUIPMENT: `${apiUrl}/equipment`,
  EQUIPMENT_BY_LOCATION: `${apiUrl}/equipment/byLocation`,
  TAGS: `${apiUrl}/equipment/tags`,
  EQUIPMENT_TYPES: `${apiUrl}/equipment/types`,
  DOWNLOAD_EQUIPMENT_REPORT: `${apiUrl}/equipment/downloadEquipmentReport`,
  DOWNLOAD_TAGS_REPORT: `${apiUrl}/equipment/downloadTagsReport`,
  CREATE_EQUIPMENT: `${apiUrl}/equipment/createEquipment`,
  CREATE_TAG: `${apiUrl}/equipment/createTag`,
  ENROLL_TAG: `${apiUrl}/equipment/enrollTag`,
  UN_ENROLL_TAG: `${apiUrl}/equipment/unEnrollTag`,
  DELETE_EQUIPMENT: `${apiUrl}/equipment/deleteEquipment`,
  DELETE_TAG: `${apiUrl}/equipment/deleteTag`,
  EQUIPMENT_MOVEMENTS: `${apiUrl}/equipment/movements`,
  GET_TRIPS_DATA: `${apiUrl}/equipment-widgets/getTripsData`,
  GET_WERE_IN_USE_DATA: `${apiUrl}/equipment-widgets/getWereInUseData`,
  GET_IN_TRANSIT_DATA: `${apiUrl}/equipment-widgets/getInTransitData`,
  GET_SELECTED_EQUIPMENT_DATA: `${apiUrl}/equipment-widgets/getInStockData`,
  DOWNLOAD_MOVEMENTS_REPORT: `${apiUrl}/equipment/downloadMovementsReport`,
  DOWNLOAD_TRIPS_REPORT: `${apiUrl}/equipment-widgets/downloadTripsReport`,
  DOWNLOAD_IN_TRANSIT_REPORT: `${apiUrl}/equipment-widgets/downloadInTransitReport`,
  DOWNLOAD_WERE_IN_USE: `${apiUrl}/equipment-widgets/downloadWereInUseReport`,
  EQUIPMENT_PEAK_USAGE: `${apiUrl}/equipment-widgets/getPeakUsage`,
  EQUIPMENT_WEEKLY_PEAK_USAGE: `${apiUrl}/equipment-widgets/getWeeklyPeakUsage`,
  EQUIPMENT_MONTHLY_PEAK_USAGE: `${apiUrl}/equipment-widgets/getMonthlyPeakUsage`,
  EQUIPMENT_LOCATIONS: `${apiUrl}/equipment/locations`,
  DOWNLOAD_EQUIPMENT_LOCATIONS_REPORT: `${apiUrl}/equipment/downloadEquipmentLocationsReport`,
  GENERATED_FILE: `${apiUrl}/equipment/generatedFile`,
  EQUIPMENT_WIDGETS_ALL: `${apiUrl}/equipment-widgets/getAllWidgets`,
  // New endpoints
  EQUIPMENT_WIDGETS_SELECTED_EQUIPMENT: `${apiUrl}/equipment-widgets/selected-equipment`,
  EQUIPMENT_WIDGETS_WERE_IN_USE: `${apiUrl}/equipment-widgets/were-in-use`,
  EQUIPMENT_WIDGETS_TOTAL_TRIPS: `${apiUrl}/equipment-widgets/total-trips`,
  EQUIPMENT_WIDGETS_AVERAGE_TIME_INSTORE: `${apiUrl}/equipment-widgets/average-time-instore`,
  EQUIPMENT_WIDGETS_LONGEST_TIME_INSTORE: `${apiUrl}/equipment-widgets/longest-time-instore`,
  EQUIPMENT_WIDGETS_SHORTEST_TIME_INSTORE: `${apiUrl}/equipment-widgets/shortest-time-instore`,
  EQUIPMENT_WIDGETS_IN_TRANSIT: `${apiUrl}/equipment-widgets/in-transit`,
});

export const WEB_STORAGE_KEYS = Object.freeze({
  ALERTS_DATE_FILTERS: 'alerts_date_filters',
  ALERTS_SELECTED_DATE: 'alerts_selected_date',
  ALERTS_FILTERS: 'alerts_filters',
  DRAWER_OPENED: 'drawer_opened',
  EQUIPMENT_FILTERS: 'equipment_filters',
  AUTH_USER: 'auth_user',
  AUTH_TOKEN: 'auth_token',
  ROLE_REFRESH_TIMESTAMP: 'role_refresh_timestamp',
  MSAL_ACTIVE_ACCOUNT: 'msal_active_account'
});

export const roleConfig = Object.freeze({
  admin: {
    allowedPaths: ["*"],
    defaultRedirect: "/home",
  },
  manager: {
    allowedPaths: ["/home", "/dashboard-equipment"],
    defaultRedirect: "/home",
  },
  user: {
    allowedPaths: ["/enrollment"],
    defaultRedirect: "/enrollment",
  },
  ['TJX-Asset-Tracking']: {
    allowedPaths: ["/asset-tracking"],
    defaultRedirect: "/asset-tracking",
  },
  ['TJX-ShoppingCarts']: {
    allowedPaths: ["/home"],
    defaultRedirect: "/home",
  },
  ['TJX-Enrollment']: {
    allowedPaths: ["/enrollment"],
    defaultRedirect: "/enrollment",
  },
});
